import { render, staticRenderFns } from "./shiftsComponent.vue?vue&type=template&id=35e4ca75&"
import script from "./shiftsComponent.vue?vue&type=script&lang=js&"
export * from "./shiftsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports